import { ref, get } from 'firebase/database';
import { db } from './firebase';

/** RTDB path written by `public/check-stream-health.php` (cPanel cron). */
export const CHANNELS_HEALTH_PATH = 'channels_health';

/**
 * Health payload shape (written by the PHP cron):
 *   {
 *     generatedAt: number,         // ms epoch
 *     resultsJson: string          // stringified { [url]: { ok, status, error?, ms?, checkedAt? } }
 *   }
 *
 * The results map is stored as a JSON STRING (single RTDB key) because RTDB
 * keys cannot contain `.`, `#`, `$`, `[`, `]`, `/` — and stream URLs always do.
 * Stringifying once on the server side is faster than per-URL writes and
 * sidesteps the encoding problem entirely.
 *
 * Returns `null` when no snapshot exists or the payload is malformed.
 */
export async function fetchChannelHealthFromFirebase() {
  let snapshot;
  try {
    snapshot = await get(ref(db, CHANNELS_HEALTH_PATH));
  } catch (_) {
    return null;
  }
  if (!snapshot.exists()) return null;
  const val = snapshot.val();
  if (!val || typeof val !== 'object') return null;
  const generatedAt = typeof val.generatedAt === 'number' ? val.generatedAt : null;
  let results = null;
  if (typeof val.resultsJson === 'string') {
    try {
      const parsed = JSON.parse(val.resultsJson);
      if (parsed && typeof parsed === 'object') results = parsed;
    } catch (_) { /* fall through */ }
  } else if (val.results && typeof val.results === 'object') {
    /* Backwards-compat: allow a plain map if a future writer chooses to. */
    results = val.results;
  }
  if (!results) return null;
  return { generatedAt, results };
}
